<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.06 15.06">
        <title>green_tick</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_3" data-name="Layer 3">
                <path
                    d="M7.53,15.06A7.53,7.53,0,1,0,0,7.53,7.53,7.53,0,0,0,7.53,15.06ZM4,5.52l2.7,2.7,4.54-4.54,1.66,1.66-6.2,6.21L2.38,7.18Z"
                    fill="#93c13e"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// CheckMarkIcon.vue?4ecec355